import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";

const LOWER_LEVEL_SUFFIX = "_LOWER_LEVEL";

const resolvePermissions = (user) => {
  const contractAgent = user?.contractAgent;
  if (contractAgent?.permissions?.length) return contractAgent.permissions;
  return [];
};

const useHasPermissions = () => {
  const currentUser = useSelector((state) => state.user.user.me);
  const permissions = useMemo(() => resolvePermissions(currentUser), [currentUser]);

  const hasHigherClass = useCallback(
    (user) => {
      const userLevelStr = user?.contractAgent?.contractAgentClass?.levelValue;
      if (!userLevelStr) return false;

      const currentUserLevelStr = currentUser?.contractAgent?.contractAgentClass?.levelValue;
  if (!currentUserLevelStr) return false;

      const currentUserLevelInt = parseInt(currentUserLevelStr);
      const userLevelInt = parseInt(userLevelStr);

      return currentUserLevelInt > userLevelInt;
    },
    [currentUser]
  );

  const hasPermission = useCallback(
    (requiredPermission, user) => {
      const requiredPermissions = Array.isArray(requiredPermission) ? requiredPermission : [requiredPermission];

      return requiredPermissions.some((permission) => {
        const hasPermissionFound = permissions.some((p) => p.name?.toUpperCase() === permission.toUpperCase());
        if (!hasPermissionFound) return false;

        if (permission.includes(LOWER_LEVEL_SUFFIX)) {
          return hasHigherClass(user);
        }
        return true;
      });
    },
    [hasHigherClass, permissions]
  );

  return { hasPermission };
};

export default useHasPermissions;
